import { Button } from "antd";
import styles from "../../deliveryServices/DeliveryServices.module.css";
import GrubhubConnectCard from "./GrubHubConnectCard";

export default function GrubHubOnboarding({ handleShowNotice }) {
  return (
    <GrubhubConnectCard>
      <p className={styles.dsFormLabels}>
        Get started by tapping '<b>Connect to Grubhub</b>' and filling out the
        required form to enable delivery for your store. Make sure all
        information is accurate, as processing can take up to 24 hours or
        longer.
      </p>
      <br />
      <Button
        block
        type="primary"
        className={styles.dsLargeButton}
        onClick={handleShowNotice}
      >
        <p>CONNECT TO GRUBHUB</p>
      </Button>
    </GrubhubConnectCard>
  );
};